import { QualityRegimeOptions } from "@nens/brostar/uploadapi-client";

/**
 * Helper function to generate enum names and disabled options based on IMBRO/A selection
 */
export const getEnumNamesAndDisabled = (
  options: readonly (
    | { value: string; onlyImbroA?: boolean }
    | { value: string; onlyImbroA?: boolean; label: string }
  )[],
  qualityRegime: QualityRegimeOptions | undefined,
  maxItems?: number
) => ({
  "ui:enumNames": options.map((opt) => ("label" in opt ? opt.label : opt.value)),
  "ui:enumImbroAOnly": options.map((opt) => "onlyImbroA" in opt && opt.onlyImbroA),
  maxItems,
  uniqueItems: true,
  items: {
    "ui:enumNames": options.map((opt) => ("label" in opt ? opt.label : opt.value)),
    "ui:enumImbroAOnly": options.map((opt) => "onlyImbroA" in opt && opt.onlyImbroA),
    ...(qualityRegime !== "IMBRO/A"
      ? {
          "ui:enumDisabled": options
            .filter((opt) => "onlyImbroA" in opt && opt.onlyImbroA)
            .map((opt) => opt.value),
        }
      : {}),
  },
  ...(qualityRegime !== "IMBRO/A"
    ? {
        "ui:enumDisabled": options
          .filter((opt) => "onlyImbroA" in opt && opt.onlyImbroA)
          .map((opt) => opt.value),
      }
    : {}),
});
